import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=b7cb25e2&scoped=true&"
import script from "./TransactionInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionInfo.vue?vue&type=style&index=0&id=b7cb25e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb25e2",
  null
  
)

export default component.exports